import React, { useEffect, useRef, useState } from 'react';
import './styles.scss';
import BrandLogo from '../../../assets/icon/logo-beelajar-horizontal_143x40.svg';
import AccentDIvision from '../../../assets/img/binus-wall.png';
import BinusBCLD from '../../../assets/img/logo-binus-white.png';
import { PublicLayoutProps } from '.';
import * as Unicons from '@iconscout/react-unicons';
import {
  AppShell,
  Container,
  Flex,
  Group,
  Image,
  Burger,
  Button as ButtonMantine,
  Menu,
  Divider,
  Box
} from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { useHistory } from 'react-router-dom';
import HelmetTitle from '../../helmet_title/HelmetTitle';
import Button from '../../elements/Button';
import { useQuery } from '@tanstack/react-query';
import { getLandingPageConfig } from '../../../services/landingPage';
import { useLandingPageConfig } from '../../../hooks/useLandingPageConfig';
import { MenuList } from '../../../types/menu';
import Menus from '../Menus';
import { FiChevronDown } from 'react-icons/fi';
import Login from '../../../views/login/Login';
import { connect } from 'react-redux';
import LayoutFooter from '../main/LayoutFooter';
import { getSharepointCdnFile } from '../../../utilities';
import { BRAND_LOGO } from '../../../constants';
import useLocalStorage from '../../../hooks/useUserData';
import SearchInput from '../../elements/SearchInput';
import ReCAPTCHA from 'react-google-recaptcha';
import { CaptchaContext } from '../../../context';

const PublicLayout: React.FC<PublicLayoutProps> = (props) => {
  const { children, withLogin = true, titlePage, size = 'xl' } = props;
  const mdScreen = useMediaQuery('(max-width: 64em)');
  const [brandImage, setBrandImage] = useLocalStorage(BRAND_LOGO, null);
  const { config, setLandingPageConfig, isExpired } = useLandingPageConfig();
  const [opened, { toggle }] = useDisclosure();
  const history = useHistory();
  const [menus, setMenus] = useState<MenuList[]>([]);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [tokenReCapv2, setTokenReCapv2] = useState<string | null>(null);

  const fetchedLandingPageConfig = useQuery({
    queryKey: ['getLandingPageConfig'],
    queryFn: () => getLandingPageConfig(),
    enabled: !!isExpired,
    onSuccess: (data) => {
      setLandingPageConfig(data);
    }
  });

  const filteredLogoBranch = fetchedLandingPageConfig?.data?.logo?.filter(
    (item) => item.code === '002'
  );

  const filteredLogoBinus = fetchedLandingPageConfig?.data?.logo?.filter(
    (item) => item.code === '001'
  );
  const logoBinus = filteredLogoBinus?.length
    ? filteredLogoBinus[0].imageFilePath
    : BinusBCLD;

  const logoBrand = filteredLogoBranch?.length
    ? filteredLogoBranch[0].imageFilePath
    : BrandLogo;

  useEffect(() => {
    if (fetchedLandingPageConfig?.data?.logo) {
      setBrandImage(fetchedLandingPageConfig?.data?.logo);
    }
  }, [fetchedLandingPageConfig?.data?.logo]);

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    try {
      return JSON.parse(object.auth).userData;
    }
    catch (_) {
      return null
    }
  };

  const _userData = getUserData();

  useEffect(() => {
    if (config) {
      if (config?.sitePage.length && menus.length === 0) {
        const modData = [];
        config?.sitePage.map((menu: any, index: number) => {
          if (index !== config?.sitePage.length - 1) {
            return modData.push({
              icon: '',
              name: menu.description,
              url: `/page/${menu.permalink}`
            });
          }
          return;
        });

        const menuStaffDirectory =
          config?.sitePage[config?.sitePage.length - 1];

        setMenus((prev) => [
          ...prev,
          {
            icon: '',
            name: 'About BCL&D',
            url: '#',
            children: modData
          },
          {
            icon: '',
            name: 'Staff Directory',
            url: `/page/${menuStaffDirectory.permalink}`
          },
          ...(props.auth
            ? [
                {
                  icon: '',
                  name: 'My Learning',
                  url: `/home`
                }
              ]
            : [])
        ]);
      }
    }
  }, [config, props.auth]);

  const handleRecaptchaChange = async (token: string | null) => {
    recaptchaRef.current.reset();
    if (token) {
      setTokenReCapv2(token);
    }
  };
  return (
    <>
      <CaptchaContext.Provider value={{ recaptchaRef, tokenReCapv2 }}>
        <HelmetTitle
          title={`${titlePage ? titlePage + ' | ' : ''} Beelajar 2.0`}
        />
        <AppShell
          header={{ height: 60 }}
          navbar={{
            width: 300,
            breakpoint: 'md',
            collapsed: { desktop: true, mobile: !opened }
          }}
          padding="md"
        >
          <AppShell.Header>
            <Group
              h="100%"
              px="md"
              align="center"
              justify="space-between"
              wrap="nowrap"
            >
              <Flex
                  align="center"
                  gap={4}
              >
                <Flex
                    align="center"
                    gap={4}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      history.push('/');
                    }}
                >
                  <Image src={AccentDIvision} w={42} h={50}/>

                  <Box visibleFrom="md" component="span">
                    <Image src={getSharepointCdnFile(logoBinus)} w={130} h={40}/>
                  </Box>
                </Flex>

                <Divider
                  orientation="vertical"
                  visibleFrom="md"
                  size={'xs'}
                  color="dark"
                  mx={4}
                />

                <Image src={getSharepointCdnFile(logoBrand)} h={40} />
                <Box visibleFrom="lg" ml={16}>
                  <SearchInput
                    leftIcon={<Unicons.UilSearch />}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        if (_userData !== null) {
                          history.push(
                            `/search?search=${e.currentTarget.value}`
                          );

                          // history.push(`/s?search=${e.currentTarget.value}`);
                        } else {
                          history.push(`/s?search=${e.currentTarget.value}`);
                        }
                      }
                    }}
                  />
                </Box>
              </Flex>

              {withLogin && (
                <Group align="center" gap={4}>
                  <Group gap={4} visibleFrom="md">
                    {' '}
                    <Box hiddenFrom="lg">
                      <SearchInput
                        mdScreen={mdScreen}
                        leftIcon={<Unicons.UilSearch />}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            if (_userData !== null) {
                              history.push(
                                `/search?search=${e.currentTarget.value}`
                              );

                              // history.push(`/s?search=${e.currentTarget.value}`);
                            } else {
                              history.push(
                                `/s?search=${e.currentTarget.value}`
                              );
                            }
                          }
                        }}
                        stylesContainer={{ width: 'fit-content' }}
                      />
                    </Box>
                    {menus.map((menu, index) => {
                      if (menu.children) {
                        return (
                          <Menu key={index}>
                            <Menu.Target>
                              <ButtonMantine
                                color="rgb(123, 33, 131)"
                                variant="transparent"
                                rightSection={<FiChevronDown />}
                                px={4}
                              >
                                {menu.name}
                              </ButtonMantine>
                            </Menu.Target>

                            <Menu.Dropdown>
                              {menu.children.map((child, index) => {
                                return (
                                  <Menu.Item
                                    component="a"
                                    style={{
                                      textDecoration: 'none'
                                    }}
                                    key={index}
                                    href={child.url}
                                  >
                                    {child.name}
                                  </Menu.Item>
                                );
                              })}
                            </Menu.Dropdown>
                          </Menu>
                        );
                      }

                      return (
                        <Menu key={index}>
                          <Button
                            variant="transparent"
                            onClick={() => {
                              history.push(menu.url);
                            }}
                          >
                            {menu.name}
                          </Button>
                        </Menu>
                      );
                    })}
                    <Box visibleFrom="md">
                      <Login
                        photo={() => {
                          return props.auth
                            ? props.auth.photoProfile
                              ? getSharepointCdnFile(props.auth?.photoProfile)
                              : props.auth.azurePhoto
                              ? props.auth.azurePhoto
                              : null
                            : '';
                        }}
                      />
                    </Box>
                  </Group>

                  <Burger
                    opened={opened}
                    onClick={toggle}
                    hiddenFrom="md"
                    size="md"
                  />
                </Group>
              )}
            </Group>
          </AppShell.Header>

          {withLogin && (
            <AppShell.Navbar py="md" px={4} zIndex={99}>
              <Box px={12} mb={6}>
                <SearchInput
                  leftIcon={<Unicons.UilSearch />}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      if (_userData !== null) {
                        history.push(`/search?search=${e.currentTarget.value}`);

                        // history.push(`/s?search=${e.currentTarget.value}`);
                      } else {
                        history.push(`/s?search=${e.currentTarget.value}`);
                      }
                    }
                  }}
                  stylesContainer={{ width: '100%' }}
                />
              </Box>

              <Menus menuList={menus} />

              <Login
                photo={() => {
                  return props.auth
                    ? props.auth.photoProfile
                      ? getSharepointCdnFile(props.auth?.photoProfile)
                      : props.auth.azurePhoto
                    : '';
                }}
              />
            </AppShell.Navbar>
          )}

          <AppShell.Main pl={0} pr={0}>
            <Container fluid>{children}</Container>
          </AppShell.Main>
          <LayoutFooter />
        </AppShell>
        {!props.auth && (
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LebWxAqAAAAAPx0ws_pDOSt2bW-dLx1tbJYj6Kb"
            size="invisible"
            onChange={handleRecaptchaChange}
          />
        )}
      </CaptchaContext.Provider>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData,
    config: state.config.data
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PublicLayout);

// export default PublicLayout;
